/*--------------------------------------
SLIDER ABOUT
 --------------------------------------*/
FAQCategories = {
  init: function () {
    $(".cat-item").click(function () {
      var cat = $(this).data("cat");
      $(".cat-item").removeClass("active");
      $(this).addClass("active");

      $(".faqs-content__tabs-wrapper .tab input").prop("checked", false)
      toggleVisibility($(".tab"), true)
      toggleVisibility($(".tab." + cat), false)
    });
  }
};

function toggleVisibility(obj, hide) {
  if (hide == true) {
    $(obj).removeClass("fade");
    $(obj).delay(200).queue(function (next) {
      $(this).removeClass("active");
      next();
    });

  } else {
    $(obj).delay(200).queue(function (next) {
      $(this).addClass("active");

      $(this).delay(100).queue(function (next) {
        $(this).addClass("fade");
        next();
      });
      next();
    });
  }

}

$(function () {
  FAQCategories.init();
});